export enum ServiceErrorType {
  E500 = '500',
  E404 = '404',
  E301 = '301',
}
